import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { HEART_INLINE } from 'assets/icons/icons';
import { colors } from 'styles/colors';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { CustomIcon } from 'components/custom-icon/CustomIcon';

type Props = {
  headerText: string;
  buttonText: string;
  onClickButton: () => void;
  headerCustomStyle?: {
    fontSize?: number;
    maxWidth?: number;
  };
};

export const CTAHeart: FC<Props> = ({
  buttonText,
  headerText,
  onClickButton,
  headerCustomStyle,
}) => {
  const { minTablet } = useBreakpoints();

  return (
    <CTAWrapper minTablet={minTablet}>
      <CTAHeartContainer minTablet={minTablet}>
        <CustomIcon height={50} src={HEART_INLINE} />
        <Header
          minTablet={minTablet}
          headerFontSize={headerCustomStyle?.fontSize}
          maxWidth={headerCustomStyle?.maxWidth}
        >
          {headerText}
        </Header>
        <FullWidthButton
          type={'primary'}
          size={'large'}
          style={{ fontWeight: 500 }}
          onClick={onClickButton}
        >
          {buttonText}
        </FullWidthButton>
      </CTAHeartContainer>
    </CTAWrapper>
  );
};

const CTAWrapper = styled.div<{ minTablet: boolean }>`
  min-height: calc(100vh - 66.28px);
  padding: ${({ minTablet }) => `32px ${minTablet ? 16 : 0}px 120px`};
`;

const CTAHeartContainer = styled.div<{ minTablet: boolean }>`
  background-color: ${colors.gray8};
  padding: ${({ minTablet }) => (minTablet ? '60px' : '60px 8px')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.p<{ minTablet: boolean; headerFontSize?: number; maxWidth?: number }>`
  margin-bottom: 50px;
  text-align: center;
  font-size: ${({ minTablet, headerFontSize }) =>
    `${headerFontSize ? headerFontSize : minTablet ? 40 : 28}px`};
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'unset')};
`;

const FullWidthButton = styled(Button)`
  width: 100%;
`;
